<template>
  <div class="box11">
    <scrollBox
      scrollwidth="0.8"
      scrollHeight="0.08"
      scrollColor="#FFAB9A"
      blockwidth="0.266667"
      blockColor="#FF5731"
      step="28"
    >
      <div
        class="item"
        v-for="(item, index) in 3"
        :key="index"
        :style="
          `background-image: url(` +
          require(`../../../assets/coursePage/newMedia/box11/${
            index + 1
          }.png`) +
          `)`
        "
      ></div>
    </scrollBox>
    <img
      class="img1"
      src="../../../assets/coursePage/newMedia/box11/img.png"
      alt=""
    />
  </div>
</template>

<script>
import scrollBox from "../common/scrollBox.vue";
export default {
  data() {
    return {};
  },
  components: {
    scrollBox,
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.box11 {
  padding-top: 80px;
  background: #fefef3;
  padding-bottom: 88px;
}
.item {
  width: 421px;
  height: 474.3333px;
  background: #fffbfa;

  border-radius: 14px;
  background-size: cover;
  flex-shrink: 0;
  margin-left: 30px;
  margin-bottom: 16px;
}
.item:nth-child(2) {
  width: 880px;
}
.item:nth-child(3) {
  width: 422px;
  font-size: 60px;
  font-size: 20px;
}
.img1 {
  width: 738px;
  margin: 48px auto 0;
}
</style>
